import React, { useState } from 'react';
import { authService } from '../services/authService';
import { useAuth } from '../hooks/useAuth';

const AuthTest = () => {
  const { login, register, logout, sendOTP, verifyOTP } = useAuth();
  const [testResult, setTestResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testLogin = async () => {
    setLoading(true);
    try {
      const result = await authService.login({
        email: 'test@example.com',
        password: 'password123'
      });
      setTestResult(`Login successful: ${JSON.stringify(result)}`);
    } catch (error) {
      setTestResult(`Login failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testRegister = async () => {
    setLoading(true);
    try {
      const result = await authService.register({
        name: 'Test User',
        email: 'test@example.com',
        password: 'password123'
      });
      setTestResult(`Registration successful: ${JSON.stringify(result)}`);
    } catch (error) {
      setTestResult(`Registration failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testLogout = async () => {
    setLoading(true);
    try {
      await authService.logout();
      setTestResult('Logout successful');
    } catch (error) {
      setTestResult(`Logout failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testSendOTP = async () => {
    setLoading(true);
    try {
      const result = await authService.sendOTP({
        email: 'test@example.com'
      });
      setTestResult(`OTP sent: ${JSON.stringify(result)}`);
    } catch (error) {
      setTestResult(`OTP send failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testVerifyOTP = async () => {
    setLoading(true);
    try {
      const result = await authService.verifyOTP({
        otp: '123456',
        email: 'test@example.com'
      });
      setTestResult(`OTP verified: ${JSON.stringify(result)}`);
    } catch (error) {
      setTestResult(`OTP verification failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Authentication Test</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <button
          onClick={testLogin}
          disabled={loading}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
        >
          Test Login
        </button>
        
        <button
          onClick={testRegister}
          disabled={loading}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 disabled:opacity-50"
        >
          Test Register
        </button>
        
        <button
          onClick={testLogout}
          disabled={loading}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 disabled:opacity-50"
        >
          Test Logout
        </button>
        
        <button
          onClick={testSendOTP}
          disabled={loading}
          className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 disabled:opacity-50"
        >
          Test Send OTP
        </button>
        
        <button
          onClick={testVerifyOTP}
          disabled={loading}
          className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 disabled:opacity-50"
        >
          Test Verify OTP
        </button>
      </div>
      
      <div className="bg-gray-100 p-4 rounded">
        <h2 className="font-semibold mb-2">Test Result:</h2>
        <pre className="whitespace-pre-wrap break-words">{testResult}</pre>
      </div>
    </div>
  );
};

export default AuthTest;